import type { FC } from "react";
import { mergeClasses } from "@huub-web/utils";
import type { ClassNameProp } from "@huub-web/ui";

import {
  pageBreakStyle,
  pageBreakFooterLeftStyle,
  pageBreakFooterRightStyle,
  pageBreakFooterStyle,
} from "./PageBreak.css";

export type PageBreakProps = ClassNameProp;

export const PageBreak: FC<PageBreakProps> = ({ className }) => (
  <div className={mergeClasses(pageBreakStyle, className)} aria-hidden="true">
    <div
      className={mergeClasses(pageBreakFooterLeftStyle, pageBreakFooterStyle)}
    />
    <div
      className={mergeClasses(pageBreakFooterRightStyle, pageBreakFooterStyle)}
    />
  </div>
);
